import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
export function RegistrationLinks() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1216">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1217">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12" data-id="element-1218">
          <a href="#" className="flex items-center justify-center gap-2 py-4 px-6 rounded-xl font-semibold text-sm transition-all hover:opacity-90 text-center" style={{
          backgroundColor: '#1e3d2f',
          color: '#c8a84b',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1219">
            <ExternalLinkIcon size={16} data-id="element-1220" />
            FLSC Members — Register for Class
          </a>
          <a href="#" className="flex items-center justify-center gap-2 py-4 px-6 rounded-xl font-semibold text-sm transition-all hover:opacity-90 text-center border-2" style={{
          backgroundColor: '#ffffff',
          borderColor: '#1e3d2f',
          color: '#1e3d2f',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1221">
            <ExternalLinkIcon size={16} data-id="element-1222" />
            Non-Members — Register for Class
          </a>
        </div>
      </div>
    </div>;
}